/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GlobalSettingList } from '../../models/global-setting-list';

export interface GlobalMappingSettingsGlobalSettingList$Params {
}

export function globalMappingSettingsGlobalSettingList(http: HttpClient, rootUrl: string, params?: GlobalMappingSettingsGlobalSettingList$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalSettingList>> {
  const rb = new RequestBuilder(rootUrl, globalMappingSettingsGlobalSettingList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GlobalSettingList>;
    })
  );
}

globalMappingSettingsGlobalSettingList.PATH = '/GlobalMappingSetting/globalSettingList';
